const $$splitComponentImporter = () => import('/data/circle/current/app/javascript/react/tanstack_routes/_protected/_settingsLayout/members/invite/$.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute, redirect } from "@tanstack/react-router";
export const Route = createFileRoute("/_protected/_settingsLayout/members/invite/$")({
  beforeLoad: ({
    location
  }) => {
    redirect({
      href: location.href.replace("/members/invite", "/settings/members/invite"),
      replace: true,
      state: location.state,
      throw: true
    });
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});